define(function(require){
	'use strict';

	var Marionette = require('marionette');


	return Marionette.ItemView.extend({
		template : 'Записей нет',
		className: 'b-mc__empty'
	});
});